var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('btn-upload-file-input',{attrs:{"ticket":_vm.ticket,"event":_vm.event}}),_vm._v(" "),_c('btn-take-photos',{attrs:{"ticket":_vm.ticket,"event":_vm.event}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71cb6431","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tickets/Actions/TicketsUploadImages.vue
// module id = 9NRq
// module chunks = 10